export enum AccommodationTypeOf {
  HBA = "HBA",
  Consultant = "Consultant",
  Directly = "Directly"
}
